// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HuddleVisitCard-module__row___ewdpN {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr);
  align-items: stretch;
  gap: 12px;
}

.HuddleVisitCard-module__card___ajp9q {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1.5px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.HuddleVisitCard-module__card___ajp9q > * + * {
  border-top: 1px solid #e4e4e7;
}

.HuddleVisitCard-module__headerSection___X9QIl {
  padding: 16px 20px;
  cursor: pointer;
}

.HuddleVisitCard-module__headerSection___X9QIl:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: -2px;
}

.HuddleVisitCard-module__headerRow___YQ6BE {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.HuddleVisitCard-module__titleLine___brEvy {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.HuddleVisitCard-module__dot___XnmsS {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  flex-shrink: 0;
}

.HuddleVisitCard-module__visitType___BqsDd {
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
}

.HuddleVisitCard-module__timeSpan___HoD7H {
  font-size: 13px;
  color: #71717a;
}

.HuddleVisitCard-module__linkOuts___IKmso {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.HuddleVisitCard-module__linkChip___kEnRp {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  padding: 6px 14px;
  font-size: 13px;
  color: #3f3f46;
  background: #ffffff;
  border: 1px solid #d4d4d8;
  border-radius: 999px;
  text-decoration: none;
  cursor: pointer;
}

.HuddleVisitCard-module__linkChip___kEnRp:hover {
  border-color: #18181b;
  color: #18181b;
}

.HuddleVisitCard-module__metaLine___ysu3M {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
  font-size: 13px;
  color: #3f3f46;
}

.HuddleVisitCard-module__memberName___oG7aR {
  font-weight: 600;
  color: #18181b;
}

.HuddleVisitCard-module__metaDivider___tl23i {
  color: #d4d4d8;
}

.HuddleVisitCard-module__athenaNote___Is1oy {
  margin-top: 6px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 13px;
  color: #52525b;
}

.HuddleVisitCard-module__athenaNoteIcon___uFZoR {
  flex-shrink: 0;
  margin-top: 2px;
  color: #a1a1aa;
}

.HuddleVisitCard-module__athenaNoteLabel___HBsat {
  color: #71717a;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/HuddleVisitCard/HuddleVisitCard.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0CAAA;EACA,oBAAA;EACA,SAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;AACF;;AAKA;EACE,6BAAA;AAFF;;AAKA;EACE,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,0BAAA;EACA,oBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;AAFF;;AAKA;EACE,qBAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF","sourcesContent":[".row {\n  display: grid;\n  grid-template-columns: 84px minmax(0, 1fr);\n  align-items: stretch;\n  gap: 12px;\n}\n\n.card {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1.5px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n\n// Every direct child of the card is a full-width row; this puts a hairline\n// between each consecutive pair, matching the prototype's Checklist\n// (divide-y) pattern instead of each section owning its own border.\n.card > * + * {\n  border-top: 1px solid #e4e4e7;\n}\n\n.headerSection {\n  padding: 16px 20px;\n  cursor: pointer;\n}\n\n.headerSection:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: -2px;\n}\n\n.headerRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.titleLine {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.visitType {\n  font-size: 15px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.timeSpan {\n  font-size: 13px;\n  color: #71717a;\n}\n\n.linkOuts {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.linkChip {\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n  padding: 6px 14px;\n  font-size: 13px;\n  color: #3f3f46;\n  background: #ffffff;\n  border: 1px solid #d4d4d8;\n  border-radius: 999px;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.linkChip:hover {\n  border-color: #18181b;\n  color: #18181b;\n}\n\n.metaLine {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n  font-size: 13px;\n  color: #3f3f46;\n}\n\n.memberName {\n  font-weight: 600;\n  color: #18181b;\n}\n\n.metaDivider {\n  color: #d4d4d8;\n}\n\n.athenaNote {\n  margin-top: 6px;\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: 13px;\n  color: #52525b;\n}\n\n.athenaNoteIcon {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: #a1a1aa;\n}\n\n.athenaNoteLabel {\n  color: #71717a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `HuddleVisitCard-module__row___ewdpN`,
	"card": `HuddleVisitCard-module__card___ajp9q`,
	"headerSection": `HuddleVisitCard-module__headerSection___X9QIl`,
	"headerRow": `HuddleVisitCard-module__headerRow___YQ6BE`,
	"titleLine": `HuddleVisitCard-module__titleLine___brEvy`,
	"dot": `HuddleVisitCard-module__dot___XnmsS`,
	"visitType": `HuddleVisitCard-module__visitType___BqsDd`,
	"timeSpan": `HuddleVisitCard-module__timeSpan___HoD7H`,
	"linkOuts": `HuddleVisitCard-module__linkOuts___IKmso`,
	"linkChip": `HuddleVisitCard-module__linkChip___kEnRp`,
	"metaLine": `HuddleVisitCard-module__metaLine___ysu3M`,
	"memberName": `HuddleVisitCard-module__memberName___oG7aR`,
	"metaDivider": `HuddleVisitCard-module__metaDivider___tl23i`,
	"athenaNote": `HuddleVisitCard-module__athenaNote___Is1oy`,
	"athenaNoteIcon": `HuddleVisitCard-module__athenaNoteIcon___uFZoR`,
	"athenaNoteLabel": `HuddleVisitCard-module__athenaNoteLabel___HBsat`
};
module.exports = ___CSS_LOADER_EXPORT___;
